'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useButtonbarContext, ButtonbarButtonContext } from './buttonbar.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useId } from '../../hooks/use-id.js';
import { RenderComp } from '../core/render-comp.component.js';
import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
const ButtonbarButton = renderWithRef('ButtonbarButton', null, (n, s)=>{
    let { value: u, children: b, id: l, onChange: f } = n, { variant: y, selectedValues: O, selectedValue: d, onSelectedValuesChange: j, onSelectedValueChange: m, name: g } = useButtonbarContext(), w = useId(l), _ = 'multi-select' === y, h = _ ? !!(null == O ? void 0 : O.includes(u)) : d === u, P = _ ? (e)=>{
        e.target.checked ? j([
            ...O || [],
            u
        ], e) : j((O || []).filter((e)=>e !== u), e);
    } : (e)=>{
        e.target.checked && m(u, e);
    };
    return jsxs(Fragment, {
        children: [
            jsx(RenderComp, {
                root: "input",
                forwardedRef: s,
                props: _object_spread_props(_object_spread({
                    type: _ ? 'checkbox' : 'radio'
                }, n), {
                    id: w,
                    name: g,
                    value: u,
                    checked: h,
                    onChange: composeEventHandlersUtil(f, P)
                }),
                classNames: [
                    _ ? 'swan-checkbox' : 'swan-radio'
                ]
            }),
            jsx(ButtonbarButtonContext.Provider, {
                value: {
                    inputId: w
                },
                children: b
            })
        ]
    });
});

export { ButtonbarButton };
